var map = {
	"./embedded_recruitment.svg": 55317,
	"./executive_search.svg": 89500,
	"./faq_candidate.svg": 66642,
	"./faq_company.svg": 51553,
	"./nearshoring.svg": 19350,
	"./outsourcing.svg": 45792,
	"./recruitment_selection.svg": 77777,
	"./setaSlider.svg": 68915,
	"./setaSliderAzul.svg": 24172
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26351;